import React from 'react';
import '../style/TeamTagPill.css';
import { CloseIcon } from '@/assets/icons/icons';
import EllipsisTooltip from '../EllipsisTooltip';

export interface TeamTagPillProps {
  name: string;
  color?: string;
  onRemove?: (e: React.MouseEvent) => void;
  removable?: boolean;
  className?: string;
}

const TeamTagPill: React.FC<TeamTagPillProps> = ({
  name,
  color = '#000',
  onRemove,
  removable = true,
  className = '',
}) => {
  return (
    <div className={`team-tag-pill ${className}`.trim()}>
      <span
        className='team-tag-pill-dot'
        style={{
          backgroundColor: color || '#000',
        }}
      />
      <EllipsisTooltip text={name} className='team-tag-pill-text' />
      {removable && onRemove && (
        <span
          className='team-tag-pill-remove'
          onClick={onRemove}
          role='button'
          aria-label={`Remove ${name}`}
        >
          <CloseIcon />
        </span>
      )}
    </div>
  );
};

export default TeamTagPill;
